const {algoliasearch, instantsearch, '@algolia/autocomplete-js':autocompletejs } = window;
const {autocomplete, getAlgoliaResults} = autocompletejs;
const appId = '82XH04CD1N', apiKey = '846a87cfcea864bec3e3434305f65d14';

const searchClient = algoliasearch(appId, apiKey);
const index = 'prod_'+language;


//if (!directAjax) function directAjax() {}

function getPrices(ids) {
  return new Promise(function (resolve, reject) {
    let languageId = {'en':19, 'fr':18}[language] || 18;
    directAjax('products.products', 'prix', [ids, languageId], function (rs) {
      resolve(rs.result);
    }, function () {
      reject();
    });
  });
}

const search = instantsearch({
  indexName: index,
  searchClient,
  insights: true
});

const searchFn = searchClient.search.bind(searchClient);
searchClient.search = async (queries) => {

  let fullCall = !queries[0].rapid;
  delete queries[0].rapid;

  if(fullCall){
    let hitDetail = $('#HitsDetails');
    hitDetail.hide();

    let loading = $('#sloading');
    if(loading.length == 0) {
      $('#hits').prepend('<div id="sloading">&nbsp</div>');
      loading = $('#sloading');

      loading.html(`<ol class="productThumbList mainProductsList">${[...Array(16)].map(_=>'<li class="productThumb"><article class="a-shadow"></article></li>').join('')}</ol>`);
    }
    loading.show();
    loading.next().hide();
    const {results} = await searchFn(queries);


    let html = results[0].nbHits + ' ' + (results[0].nbHits > 1 ? __("produits trouvés") : __("produit trouvé"));
    hitDetail.text(html);
    hitDetail.show();

    // retrieve the pricing information from an external source
    const priceTags = await getPrices(results[0].hits.map((hit) => hit.objectID));

    loading.hide();
    loading.next().show();

    return {
      results: results.map((result) => ({
        ...result,
        hits: result.hits.map((hit) => ({
          ...hit,
          ...priceTags[hit.objectID],
        })),
      })),
    };
  } else {
    return await searchFn(queries);
  }
}


let __queryID = getCookie('__queryID');
setCookie('__queryID', '', -1);


const searchfield = autocomplete({
  insights: true,
  container: '#autocomplete',
  placeholder: 'Mots clé ou code de produit',
  onSubmit({state}){
    let url = baseUrl+(language==='fr'?'/catalogue/recherche':'/catalog/search')+'?search=';
    location.href = url+state.query;
  },
  getSources() {
    return [
      {
        sourceId: 'products',
        getItemUrl({ item }) {
          return item.url.replace('https://www.brassardburo.com', baseUrl);
        },
        getItems({ query }) {
          return getAlgoliaResults({
            searchClient,
            queries: [{
              rapid: true,
              indexName: index,
              query,
              params: {
                hitsPerPage: 15,
              },
            }],
          });
        },
        templates: {
          item({item, components, html, sendEvent}) {
            return html`
                  <a href="${item.url.replace('https://www.brassardburo.com', baseUrl)}" onclick="${()=>{
                    setCookie('__queryID', item.__autocomplete_queryID);
                  }}">${components.Highlight({ attribute: 'name', hit:item })} <span class="productNo">#${components.Highlight({ attribute: 'brassardBuroId', hit:item })}</span></a>
              `;
          }
        }
      },
    ];
  }
});

searchfield.init = function() {};

if($('#hits')) {

  // Sort by
  const sortBy = instantsearch.connectors.connectSortBy((renderOptions, isFirstRender) => {
    // Rendering logic
    const { options, currentRefinement, canRefine, refine } = renderOptions;

    window.change = (event) => {
      refine(event.target.value);
    };

    if(isFirstRender) {
      document.querySelector('#sort-by').innerHTML = `
      <label for="formSortBy">${__("Tri :")}</label>

      <div class="select">
          <div class="selectIcon"></div>
          <span class="value"></span>

          <select id="sort-by-select" name="formSortBy" onchange="change(event)"></select>
      </div>
    `;
    }

    const container = document.querySelector('#sort-by-select');
    container.innerHTML = `
      ${options.map(option => `
        <option value="${option.value}" ${option.value === currentRefinement ? 'selected' : ''}>${option.label}</option>
      `).join('')}
    `;

  });


  // Configuration de base.
  let conf = {
    hitsPerPage: hitsPerPage,
  }
  console.log('category', category);
  if(category) conf.filters = category;
  // if(category) conf.filters = `categories: "${category}"`;
  // if(category) conf.filters = `hierarchicalCategories: "${category}"`;
  if(query) conf.query = query;

  search.addWidgets([
    instantsearch.widgets.configure(conf),
    searchfield,
    sortBy({
      items: [
        { label: __('Pertinence'), value: index },
        { label: __('Nom croissant'), value: index+'_name_asc' },
        { label: __('Nom décroissant'), value: index+'_name_desc' },
        { label: __('Prix croissant'), value: index+'_price_asc' },
        { label: __('Prix décroissant'), value: index+'_price_desc' },
        { label: __('# produit croissant'), value: index+'_product_asc' },
        { label: __('# produit décroissant'), value: index+'_product_desc' },
        // { label: __('# fournisseur croissant'), value: 'asc()' },
        // { label: __('# fournisseur décroissant")'), value: 'desc()' },
      ]
    }),
    instantsearch.widgets.pagination({
      container: '#pagination',
    }),
    instantsearch.widgets.hits({
      insights: true,
      container: '#hits',
      cssClasses: {
        list: ['productThumbList', 'mainProductsList'],
        item: ['productThumb']
      },
      transformItems(items) {
        return items.map((item) => {
          item.isFederal = item.isFederal === '1' && isFederal;
          item.isQuebec = item.isQuebec === '1' && isQuebec;
          item.url = item.url.replace('https://www.brassardburo.com', baseUrl);
          return item;
        });
      },
      templates: {
        item(hit, {html, sendEvent}) {
          return html`
          <article>
            ${hit.isFederal ? html`<img class="federal federalProduct"
                                        src="${templateUrl}/images/icons/canada.png"/>` : ''}
            ${hit.isQuebec ? html`<img class="federal federalProduct"
                                       src="${templateUrl}/images/icons/quebec.png"/>` : ''}
            <a class="productPictureWrapper" href="${hit.url}" onClick="${() => {
              setCookie('__queryID', hit.__queryID);
            }}">
              <img class="productPicture" src="${hit.picture}" alt="" width="221" height="150"/>
            </a>
            <h2 class="productName">${hit.name}</h2>
            <h3 class="productFullname">${hit.categories[0]}</h3>
            <p class="productSmallDetails"># Produit : ${hit.brassardBuroId} <br/>
              Statut inventaire : <span class="${hit.status_class}">
                ${hit.status_text}
                ${hit.status_equivalent_url ? html`<a href="${hit.status_equivalent_url}">${hit.status_equivalent_text}</a>` : ``}
              </span>
            </p>
            <h4 class="priceTags">
              ${hit.emptyStock ? html`<span class="emptyStock">${hit.emptyStock}</span>` : ''}
              ${hit.priceTags}
              ${hit.priceCutBlock ? html`<br/><span class="block priceCut">${hit.priceCutBlock} ${hit.priceCutBlockBold ? html`<span class="text-large bold">${hit.priceCutBlockBold}</span>` : ''}</span>` : ''}
              ${hit.priceCutBlockStroke ? html`<span class="block priceCut stroke">${hit.priceCutBlockStroke}</span>` : ''}
              ${hit.priceCut ? html`<span class="priceCut">${hit.priceCut}</span>` : ''}
              ${hit.ecofrais ? html`<span class="block ecofrais">${hit.ecofrais}</span>` : ''}
            </h4>
            <div class="cartSection">
              <input id="qty-${hit.objectID}" class="inputQty enterQty" name="" type="text" value="1"/>
              <div class="clear"></div>
              ${connected ? html`
                <button type="button" class="mediumButton" title="Ajouter à vos favoris" onclick="${(event) => {
                  event.stopPropagation();
                  addToWishlist(hit.objectID)
                }}"><i class="fas fa-heart"></i></button>` : ''}

              <button type="button" class="mediumButton cartButton" onclick="${(event) => {
                event.stopPropagation();
                addToCart(hit.objectID, $('#qty-' + hit.objectID).val(), true);
                console.log(hit.__queryID);
                aa('convertedObjectIDsAfterSearch', {
                  userToken: userToken, // required for Node.js
                  eventName: 'Product Added to Cart after Search',
                  index: index,
                  queryID: hit.__queryID,
                  objectIDs: [hit.objectID]
                });
              }}">
                <i class="fas fa-shopping-cart"></i> Ajouter au panier
              </button>
            </div>
          </article>
        `
        },
      },
    }),
  ]);
}

(function(){
  let config = {
    appId: appId,
    apiKey: apiKey,
    useCookie: true
  };
  if(userToken) {
    config.userToken = userToken;
    setCookie('_ALGOLIA', userToken);
  } else {
    userToken = config.userToken = getCookie('_ALGOLIA');
  }
  setTimeout(function(){
    aa('init', config);
    search.start();
  });
})();

